$(document).ready(function() {
  if ($('body.woocommerce-cart').length > 0) {
    cookieValue  = getCookie('lastpage');
    var lastPage = decodeURIComponent(cookieValue);
    $('.backToPage').attr('href', lastPage);
  }
});
